import { CUSTOMIZE_INVOICE_CODE_TOUR_TARGETS } from './customize-invoice-code.targets'
import { CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGETS } from './customize-invoice-template.targets'
import { SETUP_STORE_LOGO_TOUR_TARGETS } from './setup-store-logo.targets'
import type { TourTargetCatalogEntry } from './types'

export const INVOICE_TOUR_TARGET_CATALOG = {
  ...SETUP_STORE_LOGO_TOUR_TARGETS,
  ...CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGETS,
  ...CUSTOMIZE_INVOICE_CODE_TOUR_TARGETS,
} as const satisfies Record<string, TourTargetCatalogEntry>

export type InvoiceTourTargetKey = keyof typeof INVOICE_TOUR_TARGET_CATALOG
